document.addEventListener("DOMContentLoaded", function() {
    let map         = document.querySelector('[data-project-map]'),
        tooltips    = document.querySelectorAll('[data-area-tooltip]');
    if (map) {
        map.addEventListener("mousemove", function (e) {
            let target = e.target;

            if (target.nodeName === 'path') {
                let areaId = target.getAttribute('data-id_zs');
                let currentTooltip = document.querySelector('.js-tooltip-zs-' + areaId);

                tooltips.forEach(function (el) {
                    el.classList.remove('active');
                });
                currentTooltip.classList.add('active');
                currentTooltip.style.top = e.offsetY + 'px';
                currentTooltip.style.left = e.offsetX + 'px';
            } else {
                tooltips.forEach(function (el) {
                    el.classList.remove('active');
                });
            }
        });
    }
});